// extracted by mini-css-extract-plugin
export default {"shift-list__header-icon":"zq8nE1swOdEVLf3DoKCt"};